import React from "react";
import PropTypes from "prop-types";
import messages from "components/messagesDescription";
import { FormattedMessage } from "react-intl";
import withMatchMediaProps from "@hocs/with-match-media-props";

const UploaderIcon = ({ size, isNarrowScreen, isMandatory = true }) => {
  const containerStyleSmall = {
    width: isNarrowScreen ? "160px" : "220px",
    height: isNarrowScreen ? "160px" : "254px",
    backgroundImage: 'url( "/assets/images/upload-file.png")',
    backgroundSize: "cover",
    backgroundPosition: "center",
    textAlign: "center",
    border: "1px solid rgba(0, 0, 0, 0.0785)",
    cursor: "pointer",
    marginRight: "12px",
  };

  const containerStyle = {
    width: isNarrowScreen ? "160px" : "220px",
    height: isNarrowScreen ? "160px" : "254px",
    marginRight: "12px",
    backgroundImage: 'url( "/assets/images/upload-file.png")',
    backgroundSize: "cover",
    backgroundPosition: "center",
    textAlign: "center",
    border: "1px solid rgba(0, 0, 0, 0.0785)",
    cursor: "pointer",
  };

  const dragAndDropStyleSmall = { paddingTop: "15px", fontSize: "1rem" };
  const dragAndDropStyle = { paddingTop: "20px", fontSize: "1.125rem" };

  const yourFileStyleSmall = { marginBottom: "75px", fontSize: "0.75rem" };
  const yourFileStyle = { marginBottom: isNarrowScreen ? "5px" : "85px", fontSize: "0.875rem" };

  const uploadReceiptStyleSmall = { marginBottom: "8px", color: "#0f6cbe", fontSize: "0.75rem" };
  const uploadReceiptStyle = {
    marginBottom: isNarrowScreen ? "15px" : "12px",
    color: "#0f6cbe",
    marginTop: "-1.15rem",
    fontSize: ".7rem",
  };

  const uploadFileStyleSmall = {
    position: "absolute",
    top: isNarrowScreen ? "7.02rem" : "11.25rem",
    left: isNarrowScreen ? "4rem" : "5.5rem",
    marginBottom: "10px",
    color: "white",
    fontSize: isNarrowScreen ? "0.55rem" : "0.70rem",
    fontWeight: isNarrowScreen ? "400" : "700",
  };
  const uploadFileStyle = isNarrowScreen
    ? {
        position: "absolute",
        top: "7.02rem",
        left: "3.9rem",
        marginBottom: "10px",
        color: "white",
        fontSize: "0.55rem",
        fontWeight: "400",
      }
    : {
        marginBottom: "10px",
        color: "white",
        fontSize: "0.775rem",
        marginLeft: "1.35rem",
        marginTop: "-2px",
      };

  const uploadReceiptTipStyleSmall = { fontSize: "0.75rem", marginTop: "50px" };
  const uploadReceiptTipStyle = { fontSize: "0.875rem" };
  return (
    <div style={size == "small" ? containerStyleSmall : containerStyle}>
      {!isNarrowScreen && (
        <div>
          <div style={size == "small" ? dragAndDropStyleSmall : dragAndDropStyle}>
            <strong>
              <FormattedMessage {...messages.claims.dragAndDrop} />
            </strong>
          </div>
          <div style={size == "small" ? yourFileStyleSmall : yourFileStyle}>
            <FormattedMessage {...messages.claims.yourFileDescription} />
          </div>
          {isMandatory && (
            <div style={size == "small" ? uploadReceiptStyleSmall : uploadReceiptStyle}>
              <FormattedMessage {...messages.claims.uploadReceiptDescription} />
            </div>
          )}
        </div>
      )}
      <div style={size == "small" ? uploadFileStyleSmall : uploadFileStyle}>
        <FormattedMessage {...messages.claims.uploadFileDescription} />
      </div>
      {!isNarrowScreen && (
        <div style={size == "small" ? uploadReceiptTipStyleSmall : uploadReceiptTipStyle}>
          (<FormattedMessage {...messages.claims.uploadReceiptTips} />)
        </div>
      )}
    </div>
  );
};

UploaderIcon.propTypes = {
  size: PropTypes.string,
  isNarrowScreen: PropTypes.string,
  isMandatory: PropTypes.bool,
};

export default withMatchMediaProps({
  isNarrowScreen: {
    maxWidth: 680,
  },
})(UploaderIcon);



// WEBPACK FOOTER //
// ./components/claim/widgets/UploaderIcon.js